import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class AgentSkillsMultiSelectListCtrl implements IController {
  skills: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  /* @ngInject */
  constructor(private agentConstants) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.agentConstants.skills;
    }
  }

  $onChanges(changes) {
    if (changes.skills) {
      this.selectedKeys = [];
      _.forEach(this.skills, (s) => {
        this.selectedKeys[s] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      skills: isSelected ? _.concat(this.skills, [option]) :
        _.filter(this.skills, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({skills: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentSkillsMultiSelectList', {
    bindings: {
      skills: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./agent-skills-multi-select-list.html').default,
    controller: AgentSkillsMultiSelectListCtrl
  });
